module.exports = __webpack_public_path__ + "static/media/swap.beb35b02.svg";